import { deleteObject, listAll, ref } from "firebase/storage";
import { useState } from "react";
import * as Sentry from "@sentry/react";
import { storage } from "../api/firebaseApi";
import { DATABASE } from "../types/tables-data";

export const useDeleteFileFromDB = () => {
  const [isLoadingDeleteFile, setIsLoadingDeleteFile] = useState(false);
  const deleteFolderContents = async (path: string) => {
    const folderRef = ref(storage, path);

    try {
      // List all items (files) and prefixes (folders) under your specified reference
      const listResults = await listAll(folderRef);

      // Check if the folder is empty or does not exist
      if (listResults.items.length === 0 && listResults.prefixes.length === 0) {
        return; // Return early if there are no files or subfolders
      }

      // Recursively delete all items (files)
      const deletePromises = listResults.items.map((itemRef) =>
        deleteObject(itemRef)
      );

      // If you also have subfolders, you would recursively call deleteFolderContents for each prefix
      const deleteFolderPromises = listResults.prefixes.map((prefixRef) =>
        deleteFolderContents(prefixRef.fullPath)
      );

      // Await all promises from the deletion of files and subfolders
      await Promise.all([...deletePromises, ...deleteFolderPromises]);
    } catch (error) {
      Sentry.captureException(error);
    }
  };

  const onSubmitDeleteFile = async (path: string) => {
    const avatarRef = ref(storage, path);
    setIsLoadingDeleteFile(true);

    try {
      await deleteObject(avatarRef);
    } catch (error) {
      Sentry.captureException(error);
    } finally {
      setIsLoadingDeleteFile(false);
    }
  };

  const onDeleteAllLawyerFiles = async (lawyerId: string) => {
    const listRef = ref(storage, `${DATABASE.LAWYERS}/avatars/${lawyerId}`);
    try {
      const res = await listAll(listRef);
      res.items.forEach(async (itemRef) => {
        const storageRef = ref(storage, itemRef.fullPath);
        await deleteObject(storageRef);
      });
    } catch (e) {
      Sentry.captureException(e);
    }
  };

  const onDeleteClientAvatar = async (
    clientId: string,
    path = DATABASE.CLIENTS
  ) => {
    const listRef = ref(storage, `${path}/avatars/${clientId}`);
    try {
      const res = await listAll(listRef);
      res.items.forEach(async (itemRef) => {
        const storageRef = ref(storage, itemRef.fullPath);
        await deleteObject(storageRef);
      });
    } catch (e) {
      Sentry.captureException(e);
    }
  };

  return {
    deleteFolderContents,
    isLoadingDeleteFile,
    onSubmitDeleteFile,
    onDeleteAllLawyerFiles,
    onDeleteClientAvatar
  };
};
